import userStorage from '@/utils/userStorage'
import store from '@/store'

const LAST_UPDATE_DATE_KEY = 'vue-dictionary.lastUpdateDate'
const DICTIONARIES_KEY = 'vue-dictionary.dictionaries'

export const DICTIONARY_NAMES = {
  AIRCOMPANIES: 'aircompanies',
  BORT_TYPES: 'bort-types',
  FLIGHT_TYPES_STC: 'flight-types-stc'
}

export function getLastUpdateDate () {
  return userStorage.getUserData(LAST_UPDATE_DATE_KEY)
}

export function setLastUpdateDate (lastUpdateDate) {
  return userStorage.setUserData(LAST_UPDATE_DATE_KEY, lastUpdateDate)
}

export function removeLastUpdateDate () {
  return userStorage.setUserData(LAST_UPDATE_DATE_KEY, null)
}

export function putDictionariesToStorage (newDictionaries) {
  let dictionaries = getStoredDictionaries()
  Object.assign(dictionaries, newDictionaries)
  userStorage.setUserData(DICTIONARIES_KEY, dictionaries)
}

export function getStoredDictionaries () {
  return userStorage.getUserData(DICTIONARIES_KEY) || {}
}

export function getDisplayName (displayName) {
  const lang = store.getters.getLanguage
  const hasLang = displayName.hasOwnProperty(lang)
  return hasLang ? displayName[lang] : displayName.en
}

function getDictionaryItemsMap (name) {
  const dictionary = store.getters.dictionaries[name]
  let lang = store.getters.getLanguage
  return dictionary.items
    .sort((a, b) => a.orderNum < b.orderNum ? -1 : 1)
    .reduce((acc, { value, displayName, description }) => {
      const hasLang = displayName.hasOwnProperty(lang)
      acc[value] = {
        displayName: hasLang ? displayName[lang] : displayName.en,
        description: hasLang ? description[lang] : description.en
      }
      return acc
    }, {})
}

function getDictionaryItemsList (name) {
  const dictionary = store.getters.dictionaries[name]
  let lang = store.getters.getLanguage
  return dictionary.items
    .sort((a, b) => a.orderNum < b.orderNum ? -1 : 1)
    .map(({ value, displayName, description }) => {
      const hasLang = displayName.hasOwnProperty(lang)
      return {
        code: value,
        displayName: hasLang ? displayName[lang] : displayName.en,
        description: hasLang ? description[lang] : description.en
      }
    })
}

export default {
  getDictionaryItemsMap,
  getDictionaryItemsList,
  DICTIONARY_NAMES
}



// WEBPACK FOOTER //
// ./src/utils/dictionary.js